// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 504 ? "technology.anim.min" : chunkId) + "." + {"504":"168448532b039b07fb2b","757":"6f87bd517c2f1b8fd756"}[chunkId] + ".js";
};